let currentenv = process.env.NODE_ENV;
let nodeAppUrl = process.env.REACT_APP_BACKEND_URL;

// if(currentenv === "development"){
//     nodeAppUrl = process.env.REACT_APP_LOCAL_URL;
// }else{
//     nodeAppUrl = process.env.REACT_APP_LIVE_URL;
// }

console.log("Backend URL:",nodeAppUrl);

export const BackendURL = nodeAppUrl;